export default __webpack_public_path__ + "static/media/GraficoIconGrey.547987c0.svg";